import { useApiQuery } from "../../../api/hooks";
import type { InboxEntry, SmeCardView } from "../../../api/types";
import { handOverRun } from "./walk";

export interface CardWalkView {
  /** The cards of the card's hand-over in walk order (for the beads). Empty outside a hand-over, and until the inbox is read. */
  run: InboxEntry[];
  /** "Card `position` of `total`", worked out by the server; null when the server has no walk for this card. */
  position: number | null;
  total: number | null;
  /** The card is in a hand-over, so the walk stays inside it. */
  inHandOver: boolean;
  previousCardId: string | null;
  nextCardId: string | null;
}

/**
 * Where an SME card stands in its walk (UI-04). The place and the cards on either side are the server's (`SmeCardView.walk`,
 * `prev_element_id`, `next_element_id`), so "Next card" never leaves the hand-over and "Card n of m" counts the same cards.
 * The inbox is read only for the beads of a hand-over.
 */
export function useWalk(card: SmeCardView): CardWalkView {
  const walk = card.walk ?? null;
  const handOverId = walk?.hand_over_id ?? null;
  const inbox = useApiQuery("inbox", {}, { staleTime: 15_000, enabled: handOverId !== null });
  return {
    run: handOverId && inbox.data ? handOverRun(inbox.data, handOverId) : [],
    position: walk?.position ?? null,
    total: walk?.total ?? null,
    inHandOver: handOverId !== null,
    previousCardId: card.prev_element_id ?? null,
    nextCardId: card.next_element_id ?? null,
  };
}
